import { loadStripe } from "@stripe/stripe-js"

function initializePayment(countryCode, resolve, reject) {
  let key = null
  if (!sl.config.enable_apple_google_pay) {
    reject("Apple/Google Pay disabled")
  }
  key = sl.api.stripe.api_key
  if (key) {
    loadStripe(key)
      .then((stripeV3) => {
        if (stripeV3) {
          var request = stripeV3.paymentRequest({
            country: countryCode,
            currency: "usd",
            total: {
              amount: 1,
              label: `${sl.config.site_title} Total`,
            },
          })
          request
            .canMakePayment()
            .then((res) => {
              resolve(res)
            })
            .catch((err) => {
              reject(err)
            })
        } else {
          reject("Stripe not found")
        }
      })
      .catch((err) => reject(err))
  } else {
    reject("No Stripe Key provided")
  }
}

/**
 * Check if can make Apple/Google payment using Stripe API v3
 * @param {String} countryCode
 * @return {Promise}
 *  Promise.then(result) => result = {"applePay": true/false, "microsoftPay": true/false}
 *  Default then({}) => googlePay
 */
const canMakeAppleGooglePayment = (countryCode = "US") => {
  return new Promise((resolve, reject) => {
    initializePayment(countryCode, resolve, reject)
  })
}

export default canMakeAppleGooglePayment
